import { useState } from "react";

type Initializer<T> = (() => T) | T;

export default function useFreeze<T>(initializer: Initializer<T>): T {
	const [frozenValue] = useState<T>(initializer);

	return frozenValue;
}
